import { api } from './instance'
import type { AnomalyQueryParams, AnomaliesResponse, AnomalyResponse, AnomalyStatsResponse, AnomalyActiveCountResponse, AnomalyNotificationSettingsResponse } from '../types'

export const anomaliesApi = {
  getAnomalies: async (params: AnomalyQueryParams = {}): Promise<AnomaliesResponse> => {
    const queryParams = new URLSearchParams()
    if (params.type) queryParams.append('type', params.type)
    if (params.application) queryParams.append('application', params.application)
    if (params.acknowledged !== undefined) queryParams.append('acknowledged', String(params.acknowledged))
    if (params.timeRange) queryParams.append('timeRange', params.timeRange)
    if (params.page) queryParams.append('page', String(params.page))
    if (params.pageSize) queryParams.append('pageSize', String(params.pageSize))

    const { data } = await api.get(`/anomalies?${queryParams.toString()}`)
    return data
  },

  getById: async (id: string): Promise<AnomalyResponse> => {
    const { data } = await api.get(`/anomalies/${id}`)
    return data
  },

  acknowledge: async (id: string): Promise<AnomalyResponse> => {
    const { data } = await api.post(`/anomalies/${id}/acknowledge`)
    return data
  },

  getStats: async (timeRange?: string): Promise<AnomalyStatsResponse> => {
    const params = timeRange ? `?timeRange=${timeRange}` : ''
    const { data } = await api.get(`/anomalies/stats${params}`)
    return data
  },

  getActiveCount: async (): Promise<AnomalyActiveCountResponse> => {
    const { data } = await api.get('/anomalies/active-count')
    return data
  },

  getNotificationSettings: async (): Promise<AnomalyNotificationSettingsResponse> => {
    const { data } = await api.get('/anomalies/notification-settings')
    return data
  },

  setNotificationSettings: async (channelId: string | null): Promise<AnomalyNotificationSettingsResponse> => {
    const { data } = await api.put('/anomalies/notification-settings', { notificationChannelId: channelId })
    return data
  },

  injectTestAnomaly: async (): Promise<{ anomaly: AnomalyResponse; notificationSent: boolean; message: string }> => {
    const { data } = await api.post('/anomalies/test')
    return data
  },
}
